import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class WebPageService {
  constructor(private http: HttpClient) {}

  getPageContent(url: string) {
    return this.http.get(url, { responseType: "text" });
  }
}
